import React from 'react'
import './Ministries.css'
import '../../../App.css'
import '../SubLinks.css'
import MinistryLinks from '../MinistryLinks';
import { Link } from 'react-router-dom'

function Men() {
    return (
        <div>
            <div className='hero-container men half'>
                <h1></h1>
            </div>
        <div className='main-grid-container'>
          <div className='main-grid-item'>
        <MinistryLinks/>
        </div>
        <div className='main-grid-item'>
        <div className='main with-sublinks'>
                <h1>Men</h1>

                <div className='blockquote-container'>
                    <blockquote> Iron sharpens iron, so one man sharpens another.
                        <cite> - Proverbs 27:17</cite>
                    </blockquote>
                    </div> 

                <p>
                Understanding the responsibility God has given men to be leaders in the home, the church and the world, the men of Grace Community Fellowship labor to be equipped, challenged, and held accountable to fulfill their God given responsibilities.<br/><br/>
                The men of our church regularly meet to pray & study the scriptures together and strive to not just be hearers of the word but doers. We want to encourage men of all ages to live for God’s  glory as a blessing to Christ’ church, our families, and the world around us.<br/><br/>
                </p>
                <h3>Discipleship Opportunities Include:</h3>
                    <ul className='ul-ministries'>
                    <li>Bible Study Breakfasts</li>
                    <li>Conferences</li>
                    <li>GCF Training Fellowship</li>
                        <ul style={{listStyleType:'square',listStylePosition:'inside'}}>
                            <li>A 2 year in-depth teaching and training cohort that equips a man in God’s word, Systematics and Practical Theology to live his life as a man of God. </li>
                        </ul>
                    <li>Personal Discipleship & Counseling</li>
                    </ul>
                <br/>
                
                <p>
                If you are interested in learning more about our Men's Ministry please <Link to='/contact-us' className='p-link'>contact us</Link>.
                </p>
                
            </div>
        </div>
        </div>
        </div>
    )
}

export default Men
